<a class="user-btn" (click)="logout()" *ngIf="user.firstName">
  <div class="hp-txt-overlay flex flex-row">
    <div class="disconnect-btn">
      <img src="./assets/img/off.svg" alt="on/off btn" class="planning-on-off-btn">
    </div>
    <div class="content">
      <div *ngIf="isMorning">{{'GOOD_MORNING' | translate}}</div>
      <div *ngIf="!isMorning">{{'GOOD_EVENING' | translate}}</div>
      <div class="user-name">{{user.firstName}}</div>
    </div>
    <div class="external-client-hint" *ngIf="user.isExternal">{{'EXTERNAL_CLIENT' | translate}}</div>
  </div>
</a>
